import { useMemo } from 'react';

import { SizeChartDisplayResult, SizeRecommendationRequestResultProps } from '@vestico/model';

import { SizeRecommendationTabSelect } from './SizeRecommendationTabSelect';
import { SizeRecommendationTabSizeRec } from './SizeRecommendationTabSizeRec';

export interface SizeRecommendationDetailsProps {
  sizeRecommendation: SizeRecommendationRequestResultProps | undefined;
  sizeChart: SizeChartDisplayResult | undefined;
  showContentToggle?: boolean;
  onContentToggle?: () => void;
}

export const SizeRecommendationDetails = ({ sizeRecommendation, sizeChart, showContentToggle, onContentToggle }: SizeRecommendationDetailsProps) => {
  const {
    recommendations: sizeRecommendations,
    additionalProductAttributes,
    alternativeHintDisabled,
    customDisclaimer,
  } = sizeRecommendation ?? {
    sizeRecommendations: undefined,
    additionalProductAttributes: undefined,
    alternativeHintDisabled: undefined,
    chart: undefined,
    customDisclaimer: undefined,
  };

  const content = useMemo(() => {
    if (!sizeRecommendations) {
      return null;
    }

    return (
      <SizeRecommendationTabSizeRec
        sizeRecommendations={sizeRecommendations}
        additionalProductAttributes={additionalProductAttributes}
        alternativeHintDisabled={alternativeHintDisabled}
        onContentToggle={onContentToggle}
        customDisclaimer={customDisclaimer}
        showContentToggle={showContentToggle}
      />
    );
  }, [sizeRecommendations, additionalProductAttributes, alternativeHintDisabled, onContentToggle, customDisclaimer, showContentToggle]);

  return <SizeRecommendationTabSelect sizeChart={sizeChart} sizeRecTabContent={content} showSizeRecTab />;
};
